import { Data } from 'signup-constants/signupData/Data';
import { getQueryParam } from './getQueryParam';
export const getIsPostVerification = () => {
  const tokenQueryParam = getQueryParam(Data.Token.toLowerCase());
  return Boolean(tokenQueryParam);
};